<template>
  <div class="page">
    <div class="public-wrap">
      <brand-logo size="lg" />
      <h1>{{ $t('contact_us') }}</h1>
      <p class="place">{{ $t('public_contact_location') }}</p>
      <p>
        <a href="mailto:hello@ridelilo.com">hello@ridelilo.com</a>
      </p>
      <v-form class="mt-6" @submit.prevent="send">
        <v-text-field v-model="name" :label="$t('name')" outlined dense></v-text-field>
        <v-text-field v-model="email" :label="$t('Email')" outlined dense></v-text-field>
        <v-textarea v-model="message" :label="$t('public_contact_message')" outlined rows="5"></v-textarea>
        <v-btn color="accent" dark type="submit" depressed>{{ $t('public_contact_send') }}</v-btn>
      </v-form>
    </div>
  </div>
</template>
<script>
import BrandLogo from '@/components/BrandLogo.vue'
export default {
  components: { BrandLogo },
  data() {
    return { name: '', email: '', message: '' }
  },
  methods: {
    send() {
      const subject = encodeURIComponent(this.name || 'Contact')
      const body = encodeURIComponent((this.message || '') + '\n\n' + this.email)
      window.location.href = `mailto:hello@ridelilo.com?subject=${subject}&body=${body}`
    },
  },
}
</script>
<style scoped>
.page { padding: 48px 0 80px; }
.public-wrap { width: min(640px, calc(100% - 32px)); margin: 0 auto; }
h1 { margin: 16px 0 4px; letter-spacing: -0.03em; color: #002855; }
.place { color: #6B7280; }
</style>
